module.exports = __webpack_public_path__ + "img/5.8b0dbba5.png";